module.exports = __webpack_public_path__ + "img/Ancho_Estrategias.5baf5ea1.png";